import { useGetDocumentTemplateAvailableVariables } from '@/api/queries/documentTemplates/useGetDocumentTemplateAvailableVariables';
import { DocumentTemplateAvailableVariablesInput } from '@/gql/graphql';
import { SchemaTreeView, UntitledLoading } from '@payaca/ambrosia';

import { omit } from 'lodash-es';
import { FC } from 'react';

interface AvailableDocumentTemplateVariablesListProps {
  input: DocumentTemplateAvailableVariablesInput;
}

export const AvailableDocumentTemplateVariablesList: FC<
  AvailableDocumentTemplateVariablesListProps
> = ({ input }) => {
  const { data, isLoading } = useGetDocumentTemplateAvailableVariables(input);

  let schema = data?.documentTemplateAvailableVariables.schema;

  // TEMP: remove this after signatures feature is fully released.
  if (schema && import.meta.env.VITE_ENABLE_DOCUMENT_SIGNATORIES !== 'true') {
    schema = {
      ...schema,
      properties: omit(schema.properties, ['signatures']),
    };
  }

  return (
    <div>
      {isLoading ? (
        <UntitledLoading className="w-5 h-5" />
      ) : (
        <SchemaTreeView canCopyToClipboard schema={schema} />
      )}
    </div>
  );
};
